jQuery(document).ready(function ($) {
    var submit = function (action, fields, messageElement) {
        var formData = new FormData();
        formData.append("action", action);
        Object.keys(fields).forEach(function (key) {
            formData.append(key, fields[key]);
        });
        new AjaxForm(formData).call(function (data) {
            if (!data.success) {
                messageElement.text(data.message);
                return;
            }
            messageElement.text("");
            if (data.message.redirectUrl === "") {
                $("#login_modal").modal("hide");
                return;
            }
            document.location.href = data.message.redirectUrl;
        });
    };

    $("#login_modal_form").on("submit", function (e) {
        e.preventDefault();
        var message = $("#login_modal .login_form_message").text("");
        submit("login", {
            username: $("#login_username").val(),
            password: $("#login_password").val(),
            remember: $("#remember_me").is(":checked"),
            relog: $("#relog").val(),
            login_security: $("#login_security").val()
        }, message);
    });

    $("#signup_modal_form").on("submit", function (e) {
        e.preventDefault();
        var message = $("#signup_modal .signup_form_message").text("");
        if ($("#signup_password").val() !== $("#signup_confirm_password").val()) {
            message.text("Your passwords don't match");
            return;
        }
        submit("signup", {
            signup_username: $("#signup_username").val(),
            signup_password: $("#signup_password").val(),
            signup_confirm_password: $("#signup_confirm_password").val(),
            signup_birth_month: $("#signup_birth_month").val(),
            signup_birth_day: $("#signup_birth_day").val(),
            signup_birth_year: $("#signup_birth_year").val(),
            signup_security: $("#signup_security").val()
        }, message);
    });

    $("#signup_modal_form_teacher").on("submit", function (e) {
        e.preventDefault();
        var message = $("#signup_modal_teacher .signup_form_message").text("");
        if ($("#signup_password_teacher").val() !== $("#signup_confirm_password_teacher").val()) {
            message.text("Your passwords don't match");
            return;
        }
        var fields = {
            signup_username: $("#signup_username_teacher").val(),
            signup_first: $("#signup_first_teacher").val(),
            signup_last: $("#signup_last_teacher").val(),
            signup_school_name: $("#signup_school_name").val(),
            signup_password: $("#signup_password_teacher").val(),
            signup_confirm_password: $("#signup_confirm_password_teacher").val(),
            signup_security: $("#signup_security_teacher").val()
        };
        if ($("#signup_title_teacher").length) {
            fields.signup_title_teacher = $("#signup_title_teacher").val();
        }
        submit("signupTeacher", fields, message);
    });

    $(".pixelpad_login, #pixelpad_login").on("click", function (e) {
        e.preventDefault();
        $("#login_modal").modal("show");
    });
});
